import React, { useState } from 'react';
import withPageWrapper from '../../components/Shared/HOCs/withPageWrapper';
import FilterSection from '../../components/CategoryPages/SingInTheCommunity/Sections/FilterSection';
import Header from '../../components/CategoryPages/SingInTheCommunity/Sections/Header';
import MainSection from '../../components/CategoryPages/SingInTheCommunity/Sections/MainSection';
import useGetResources from '../../hooks/Resource/useGetResources';
import useGetSongs from '../../hooks/Song/useGetSongs';
import { returnHasTags } from '../../utils/helpers';
import { updateQuery } from '../../utils/objects';
import { buildResourceParams } from '../../utils/resource';

const SingInTheCommunity = () => {
  const [displaySongs, setDisplaySongs] = useState(true);
  const [displayResources, setDisplayResources] = useState(true);
  const [displayPlaylists, setDisplayPlaylists] = useState(true);
  const [filterParams, setFilterParams] = useState({});

  const {
    data: songs,
    loading: loadingSongs,
    fetchMore: fetchMoreSongs,
  } = useGetSongs(
    6,
    returnHasTags(
      'hasSongTags',
      'OOTA Singing School',
      'Community/Charity',
      true
    ),
    true
  );

  const {
    data: resources,
    loading: loadingResources,
    fetchMore: fetchMoreResources,
  } = useGetResources(
    2,
    returnHasTags('hasTags', 'OOTA Singing School', 'Community/Charity')
  );

  const handleFilter = (params) => {
    const resourceParams = buildResourceParams(params);

    fetchMoreSongs({
      variables: { ...params },
      ...updateQuery,
    });
    fetchMoreResources({
      variables: { ...resourceParams },
      ...updateQuery,
    });
    setDisplaySongs(true);
    setDisplayResources(true);
    setDisplayPlaylists(true);
    setFilterParams(params);
  };
  const loading = loadingResources || loadingSongs;

  return (
    <>
      <Header />
      <FilterSection loading={loading} handleFilter={handleFilter} />
      <MainSection
        songs={songs?.songs?.data}
        resources={resources?.resources?.data}
        displayResources={displayResources}
        displaySongs={displaySongs}
        displayPlaylists={displayPlaylists}
        filterParams={filterParams}
      />
    </>
  );
};

export default withPageWrapper({})(SingInTheCommunity);
